<div
  (click)="toggleClick()"
  [ngClass]="[
    active ? 'selected' : 'not-selected',
    dotActive ? 'filter-active' : '',
  ]">
  <span *ngIf="isIcon != null" [ngClass]="'icon icon-' + isIcon"></span>
  <span *ngIf="title != null">{{
    'watch.ranking_modal.filters.' + title | translate
  }}</span>
  <span *ngIf="withArrow && isIcon === null" class="triangle"></span>
</div>
